import React, { useEffect, useState, useCallback } from 'react';
import { Row, Col, Form, Button, message } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { formFields, formFields1, formFields2, formFields3 } from './formField';
import { FormField, RadioGroup } from 'components';
import { get, omit, moment } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as Cancel } from 'assets/icons/cancel_icon.svg';
import { formattedNumber, isAuditor, isBeneficiary, isInvestor, isObjectionCommittee, validAFM} from 'utils';
import { Upload } from 'components';
import SorefsisObjCommittee from 'components/sorefsisObjCommittee';
import SorefsisChart from 'components/layout/components/sorefsisChart';
import { DownloadedItems } from '../documentsBeneficiary/components';
import { flattenDocs } from '../documentsBeneficiary/utils';
import { getProjectPlanInfo, updateFormField } from 'store/forms/actions';

const ObjectionEvaluationFormAuditor = () => {
  const task = useSelector(state => state.forms.task);
  const [form] = useForm();
  const user = useSelector(state => state.user);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode || !isObjectionCommittee(user?.groups) || task.taskName !== 'task.name.application_evaluation_by_committee';
  const carrier = useSelector(state => state.forms.carrier);
  const docs = useSelector(state => state.forms.documents);
  const flatDocs = flattenDocs(docs);
  const audit = useSelector(state => state.forms.audit);
  const objCommittee = useSelector(state => state.forms.objCommittee);
  const totalAmountSorefsis = useSelector(
    state => state.forms.carrier.totalAmountSorefsis
  );
  const dispatch = useDispatch();

  const sorefsisVat = carrier?.ownerStatus === 'ownerStatusOwner' ?
                      carrier?.legalVat :
                      carrier?.ownerVat;
  const mainKad = 100; //default kad

  useEffect (() => {
    if (validAFM(sorefsisVat)) {
      dispatch(getProjectPlanInfo(sorefsisVat, mainKad));
      // Income validation is now handled by the IncomeValidationField component
    }
  },[sorefsisVat])

  useEffect(() => {

    const mapping = {
      ameaMemberAud: 'ameaMemberObjCommittee',
      powerSupplyAud: 'powerSupplyObjCommittee',
      powerSupplyPrivateAud: 'powerSupplyPrivateObjCommittee',
      powerSupplyPublicAud: 'powerSupplyPublicObjCommittee',
      legalChildrenAud: 'legalChildrenObjCommittee',
      vulnerableHouseholdAud: 'vulnerableHouseholdObjCommittee',
      otherReasonAud: 'otherReasonObjCommittee',
    };
    
    // copy vulnerableHousehold -> carrier
    if (carrier.vulnerableHousehold && !objCommittee.vulnerableHousehold) {
      dispatch(
        updateFormField({
          group: 'objCommittee',
          key: 'vulnerableHousehold',
          value: carrier.vulnerableHousehold,
        })
      );
    }

    Object.entries(mapping).forEach(([auditKey, committeeKey]) => {
      const newValue = audit[auditKey];
      const currentValue = objCommittee?.[committeeKey];

      // Only update if currentValue is nullish or empty string
      if ((currentValue === undefined || currentValue === null || currentValue === '') && newValue) {
        dispatch(
          updateFormField({
            group: 'objCommittee',
            key: committeeKey,
            value: newValue,
          })
        );
      }
    });

    form.setFieldsValue({
      ameaMember: carrier.ameaMember,
      powerSupply: carrier.powerSupply,
      powerSupplyPrivate: carrier.powerSupplyPrivate,
      powerSupplyPublic: carrier.powerSupplyPublic,
      legalChildren: carrier.legalChildren,
      vulnerableHousehold: objCommittee.vulnerableHousehold || carrier.vulnerableHousehold,
      preApprovalObjCommittee: objCommittee.preApprovalObjCommittee,
      ...objCommittee
    });
  }, [form, carrier, audit]);

  const handleChange = ({ key, type, event }) => {
    let newValue;
    if (type === 'text' || type === 'textarea' || type === 'radio') {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString("en-US");
    } else if (type === 'select' || type === 'number' || type === 'switch') {
      newValue = event;
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    }

    dispatch(
      updateFormField({
        group: 'objCommittee',
        key,
        value: newValue,
      })
    );
  };

  const renderFieldValue = field => {
    const value = get(objCommittee, field.name, '');
    return field.type === 'date' ? (value ? moment(value) : '') : value;
  };

  const updatedFormFields = formFields;


  return (
    <div>
      <Form
        form={form}
        initialValues={{...objCommittee }}
        // trigger="onChange"
      >
        <div
          className=""
          style={{ width: '55%', display: 'inline-block' }}
        >
        <p className="mt-6 mr-0 color-blue-3 text-bold font-size-24">
        Εξέταση Ένστασης 
        </p>
        
        
        <Row >
        {updatedFormFields.map((field, index) => {
            return (
              field.type !== 'empty' ? (
              <Col key={index} className="gutter-row" span={field.span}>
                <Form.Item
                  name={[field.name]}
                  rules={field.rules}
                  className="ml-5"
                  validateStatus={field.validateStatus}
                  help={field.help}
                >
                  {field.name === 'vulnerableHousehold' ? (
                    <FormField
                      key={index}
                      disabled={true}
                      style={{ pointerEvents: "none", cursor: "not-allowed" }}
                      className="custom-checkbox-disabled"
                      {...omit(field, ["span", "rules", "validateStatus", "help"])}
                      value={objCommittee.vulnerableHousehold || carrier.vulnerableHousehold || ''}
                      />
                  ) : (
                    <FormField
                      key={index}
                      disabled={!viewMode && field.name.includes("ObjCommittee") ? false : true}
                      style={
                        viewMode
                          ? { pointerEvents: "none", cursor: "not-allowed" }
                          :
                          field.name.includes("ObjCommittee") ?
                          {marginLeft: '0.5rem'}
                          : {}
                      }
                      className={`${viewMode ? "custom-checkbox-disabled" : ""}`}
                      {...omit(field, ["span", "rules", "validateStatus", "help"])}
                      onChange={(value) =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  )}
                </Form.Item>
              </Col>
            )
            : (
              <Col key={index} span={field.span} /> // Spacer
            ))
        })}
        </Row>
        </div>
        <div
          className=""
          style={{ width: '45%', display: 'inline-block' }}
        >
          <Row>
        {formFields2.map((field, index) => {
          return (
            <Col key={index} className="gutter-row" span={field.span}>
              <Form.Item
                name={[field.name]}
                rules={field.rules}
                value={renderFieldValue(field)}
              >
                <FormField
                  key={index}
                  disabled={viewMode}
                  style={
                    viewMode 
                    ? { pointerEvents: 'none', cursor: 'not-allowed' } 
                    : {}
                  }
                  className={viewMode ? 'custom-checkbox-disabled' : ''}
                  {...omit(field, ['span', 'rules'])}
                  onChange={value =>
                    handleChange({
                      key: field.name,
                      type: field.type,
                      event: value,
                    })
                  }
                />
              </Form.Item>
            </Col>
          );
        })}
        </Row>
        </div>
        <div className='mt-1' style={{ width: '45%', display: 'inline-block' }}>
          {!viewMode ? formFields3.map((item, index) => {
            return (
              <Upload item={item} subFileCode={item.fileCode} key={index} group={'documents'} />
            );
          })
        : 
          <div className='mt-2'>
              <DownloadedItems content={formFields3} docs={flatDocs} />
          </div>
        }
        </div>
        
        <Row
        gutter={{ xs: 0, sm: 2, md: 5, lg: 10 }}
        className="carrier-data-form__row mt-6 sorefsis"
      >
        <Col span={20} className="sorefsis-col-1">
          <>
            <SorefsisObjCommittee viewMode={viewMode}/>
          </>
        </Col>
        <Col span={4} className="sorefsis-col-2">
          <div className="mt-1">
            <SorefsisChart
              realValue={totalAmountSorefsis ? totalAmountSorefsis : 0}
              limit={process.env.REACT_APP_SOREFSIS_AMOUNT }
            />
          </div>
          <div>
            {!viewMode && totalAmountSorefsis > (process.env.REACT_APP_SOREFSIS_AMOUNT) && (
              <div
                role="alert"
                className="ant-form-item-explain-error mt-0 mb-2"
              >
                Το Σύνολο Σώρευσης έχει υπερβεί το Όριο Deminimis κατά{' '}
                {formattedNumber(totalAmountSorefsis - (process.env.REACT_APP_SOREFSIS_AMOUNT))}€
              </div>
            )}
          </div>
        </Col>
      </Row>
      </Form>
    </div>
  );
};

export default ObjectionEvaluationFormAuditor;